'use strict';

var _ = require('lodash');

var CommandUtils = require('./CommandUtils');
var PropertyUtils = require('./PropertyUtils');

var EditorCommands = require('../constants/EditorCommands');
var PropertyTypes = require('../constants/PropertyTypes');

/** @module CommandsBinder
 * @requires lodash
 * @requires CommandUtils
 * @requires PropertyUtils
 * @requires EditorCommands
 * @requires PropertyTypes
 */
function CommandsBinder() {
	var _bind = function(target) {
		var properties = PropertyUtils.GetAllProperties(target);
		_(properties)
			.filter(function(property) {
				var propertyData = PropertyUtils.GetPropertyData(property);
				return PropertyTypes.isTextPropertyType(propertyData.type);
			})
			.forEach(function(property) {
				//updates property value
				CommandUtils.SetCommand(property, 'input', EditorCommands.textPropertyChange);
			});
	};

	this.bind = function(target) {
		var config = {
			childList: true
		};
		this.destroy();
		this.observer = new MutationObserver(_.partial(_bind, target));
		this.observer.observe(target, config);
	};

	this.destroy = function() {
		if (!this.observer) return;

		this.observer.disconnect();
		this.observer = null;
	};
}

module.exports = CommandsBinder;
